import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2682625103 from "../../../../../packages/component/src/components/grid/demo/demo1.js?loadDemo";
import legacyImportDemo_3570437004 from "../../../../../packages/component/src/components/grid/demo/demo2.js?loadDemo";
import legacyImportDemo_1280226125 from "../../../../../packages/component/src/components/grid/demo/demo3.js?loadDemo";
import legacyImportDemo_2061682058 from "../../../../../packages/component/src/components/grid/demo/demo4.js?loadDemo";
import legacyImportDemo_2770102603 from "../../../../../packages/component/src/components/grid/demo/demo5.js?loadDemo";
import legacyImportDemo_265436296 from "../../../../../packages/component/src/components/grid/demo/demo6.js?loadDemo";
import legacyImportDemo_2098112073 from "../../../../../packages/component/src/components/grid/demo/demo7.js?loadDemo";
import legacyImportDemo_2593949830 from "../../../../../packages/component/src/components/grid/demo/demo8.js?loadDemo";
import legacyImportDemo_4141801543 from "../../../../../packages/component/src/components/grid/demo/demo9.js?loadDemo";
import legacyImportDemo_1429594495 from "../../../../../packages/component/src/components/grid/demo/demo10.js?loadDemo";
import legacyImportDemo_2332553758 from "../../../../../packages/component/src/components/grid/demo/demo11.js?loadDemo";
import legacyImportDemo_3737238973 from "../../../../../packages/component/src/components/grid/demo/demo12.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2682625103,
  legacyImportDemo_3570437004,
  legacyImportDemo_1280226125,
  legacyImportDemo_2061682058,
  legacyImportDemo_2770102603,
  legacyImportDemo_265436296,
  legacyImportDemo_2098112073,
  legacyImportDemo_2593949830,
  legacyImportDemo_4141801543,
  legacyImportDemo_1429594495,
  legacyImportDemo_2332553758,
  legacyImportDemo_3737238973,
  React
};